import { render, staticRenderFns } from "./CurrentUserMixin.vue?vue&type=template&id=71bbfca8&scoped=true"
import script from "./CurrentUserMixin.vue?vue&type=script&lang=js"
export * from "./CurrentUserMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bbfca8",
  null
  
)

export default component.exports